import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { PersonIcon } from '../icons';
import { UsernameIconContainer, LocationSection } from './index';
import { getOptionStyles, getOptionDetailsStyles } from '../helpers';

/**
 * Option content for Member/Attorney Autocomplete.
 * Renders as a div because MUI already wraps renderOption output in an <li>.
 */
const AutocompleteOption = ({
  option,
  isSelected,
  isFirstOption,
  displayName,
  displayRole,
  locationString,
  shouldShowDocId,
  shouldShowLocation,
  showDisplayNamesOnly,
  endAdornment,
}) => {
  const containerStyles = getOptionStyles(isSelected, isFirstOption);
  const detailsStyles = getOptionDetailsStyles();

  return (
    <Box style={containerStyles}>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          width: '100%',
        }}
      >
        <Box
          style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'flex-start',
            minWidth: 0,
          }}
        >
          <UsernameIconContainer
            icon={<PersonIcon role={displayRole} />}
            text={option.username || displayName}
            showDivider={!!option.username}
          />
          {!showDisplayNamesOnly && (
            <>
              <Typography style={detailsStyles}>
                {displayName}
                {shouldShowDocId && ` | DOC ID: ${option.docId}`}
                {' | '}
                {displayRole}
              </Typography>
              {shouldShowLocation && (
                <LocationSection text={locationString} />
              )}
            </>
          )}
        </Box>
        {endAdornment ? (
          <Box style={{ flexShrink: 0 }}>{endAdornment}</Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default AutocompleteOption;
